import React from 'react';

// GLOBAL VARIABLES
import { INTERFACE, DELIVERY_LOG, RECORD } from 'pathnames.js';

// GLOBAL FUNCTIONS
import { checkRole, makePath } from 'functions.js';

// ROUTER COMPONENTS
import { Navigate, Route, Routes } from 'react-router-dom';

// ROUTES
import View from './sales/view/View';
import Edit from './sales/edit/Edit';

// MAIN COMPONENT
const Sales = () => (
  <Routes>
    <Route path={makePath(RECORD.view, ':recordID')} element={<View />} />
    {checkRole(['dslAdmin', 'salesManager', 'salesManagerPlus'])
      ? [
          <Route key="salesEdit" path={makePath(RECORD.edit, ':recordID')} element={<Edit />} />,
          <Route key="salesAdd" path={makePath(RECORD.add, ':recordID')} element={<Edit />} />
        ]
      : []}
    <Route path="*" element={<Navigate to={makePath(INTERFACE.deliveryLog, DELIVERY_LOG.overview)} replace />} />
  </Routes>
);

// EXPORT
export default Sales;
